import {regReducer} from '../../core';
import * as actions from './actions';
import * as r from 'ramda';
import * as s from './selectors';

regReducer(actions.ADD_MOZZARELLA, (state) => {
    const idMozzarella = s.idMozzarella(state);
    if (idMozzarella === null) return state;

    const countLens = r.lensPath([
        'productConfigurator',
        'productConfigs',
        idMozzarella,
        'count',
    ]);

    return r.over(countLens, r.inc, state);
});

regReducer(actions.HIDE_PIZZA_CONTAINS_NO_MOZZARELLA, (state) => {
    return r.dissocPath(
        ['productConfigurator', 'showPizzaContainsNoMozzarella'],
        state
    );
});

regReducer(actions.SHOW_PIZZA_CONTAINS_NO_MOZZARELLA, (state) => {
    return r.assocPath(
        ['productConfigurator', 'showPizzaContainsNoMozzarella'],
        true,
        state
    );
});

regReducer(actions.HIDE_PIZZA_CONTAINS_ONLY_DOUGH, (state) => {
    return r.dissocPath(
        ['productConfigurator', 'showPizzaContainsOnlyDough'],
        state
    );
});

regReducer(actions.SHOW_PIZZA_CONTAINS_ONLY_DOUGH, (state) => {
    return r.assocPath(
        ['productConfigurator', 'showPizzaContainsOnlyDough'],
        true,
        state
    );
});
